import {
  Flex,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  BLUEMONEDDBUTTONS,
  VARIANT,
  WHITE,
} from "../../../../constants/colors";
import { simplifiedExtract } from "../../../../interfaces/defaultInterfaces";
import moment from "moment";
import { ToLocaleFormat } from "../../../../defaultFunctions/formaters";
import PaginacaoTabela, { usePaginaLocal } from "./paginacaoTabela";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function TableTransfers({ data, title }: any) {
  const [salesCredit, setSalesCredit] = useState(Array<simplifiedExtract>);
  useEffect(() => {
    setSalesCredit(data);
  }, [data]);

  // Paginacao local: o total do rodape continua sobre a lista inteira,
  // so o corpo da tabela passa a mostrar uma pagina por vez.
  const { pagina, setPagina, itens, totalPaginas, total, inicio, tamanho } =
    usePaginaLocal(salesCredit);
  const colors = useRecoilState(customColors)[0];

  return (
    <>
      {salesCredit.length && (
        <Flex w={"100%"} flexDirection={"column"} mt={4}>
          <Text m={4} fontSize={"16px"} fontWeight={"bold"}>
            {title}
          </Text>
          <Table variant={"striped"}>
            <TableCaption fontWeight={"bold"}>
              Total:{" "}
              {ToLocaleFormat(salesCredit.reduce((acc, i) => acc + i.valor, 0))}
            </TableCaption>
            <Thead
              h="60px"
              position="sticky"
              top="0"
              bgColor={colors.BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Data
                </Th>
                {/* <Th bgColor={VARIANT} color={WHITE}>
                  Status
                </Th> */}
                <Th
                  borderRadius={"0 8px 8px 0"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Valor
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {itens &&
                itens.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td borderRadius={"8px 0 0 8px"}>
                        {moment(item?.dataLancamento).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      {/* <Td>
                        {item?.transferencia
                          ? item.transferencia.status.status
                          : item?.pagamento
                          ? item.pagamento.status.status
                          : ""}
                      </Td> */}
                      <Td borderRadius={"0 8px 8px 0"}>
                        {item?.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <PaginacaoTabela
            pagina={pagina}
            totalPaginas={totalPaginas}
            total={total}
            inicio={inicio}
            tamanho={tamanho}
            setPagina={setPagina}
          />
        </Flex>
      )}
    </>
  );
}
